import React from 'react';

interface MarqueeProps {
  items: string[];
  className?: string;
}

/** Infinite scrolling text strip. Pure CSS animation, duplicated content. */
const Marquee = ({ items, className = '' }: MarqueeProps) => {
  const strip = (
    <div className="marquee-content" aria-hidden="true">
      {items.map((item, i) => (
        <span key={i} className="mx-6 inline-flex items-center gap-12 font-display text-2xl font-bold uppercase tracking-wide text-white/40 sm:text-4xl">
          {item}
          <span className="text-azure-500/40">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <div className={`marquee pointer-events-none select-none overflow-hidden whitespace-nowrap border-y border-white/5 py-6 ${className}`}>
      {strip}
      {strip}
    </div>
  );
};

export default Marquee;
